import React from 'react';
import { UserInfoDto } from '../../services/contracts/ContractService';

const normalizeName = (name?: string | null) => (name ?? '').trim();

interface ConsultantCreatorCellProps {
  responsible?: UserInfoDto | null;
  creator?: UserInfoDto | null;
}

const ConsultantCreatorCell: React.FC<ConsultantCreatorCellProps> = ({ responsible, creator }) => {
  const responsibleName = normalizeName(responsible?.nome || responsible?.username);
  const creatorName = normalizeName(creator?.nome || creator?.username);
  const samePerson =
    Boolean(responsible?.id && creator?.id)
    && responsible!.id.toLowerCase() === creator!.id.toLowerCase();

  if (!responsibleName && !creatorName) {
    return <span style={{ color: '#999', fontStyle: 'italic' }}>N/A</span>;
  }

  if (samePerson || (responsibleName && !creatorName) || (!responsibleName && creatorName)) {
    const name = responsibleName || creatorName;
    const email = responsible?.email || creator?.email;
    return (
      <div
        style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}
        title={[name, email].filter(Boolean).join(' · ')}
      >
        <span style={{ fontWeight: 500 }}>{name}</span>
        {email && <span style={{ fontSize: '0.85em', color: '#666' }}>{email}</span>}
      </div>
    );
  }

  return (
    <div
      style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}
      title={`Consultor Responsável: ${responsibleName} · Criado por: ${creatorName}`}
    >
      <div>
        <div style={{ fontSize: '0.75em', color: '#888', lineHeight: 1.2 }}>Consultor Responsável</div>
        <span style={{ fontWeight: 500 }}>{responsibleName}</span>
        {responsible?.email && (
          <span style={{ display: 'block', fontSize: '0.85em', color: '#666' }}>{responsible.email}</span>
        )}
      </div>
      <div>
        <div style={{ fontSize: '0.75em', color: '#888', lineHeight: 1.2 }}>Criado por</div>
        <span style={{ fontWeight: 500 }}>{creatorName}</span>
        {creator?.email && (
          <span style={{ display: 'block', fontSize: '0.85em', color: '#666' }}>{creator.email}</span>
        )}
      </div>
    </div>
  );
};

export default ConsultantCreatorCell;
